import { planets } from "./planetsData"

export function createPlanetSelector() {
  const selector = document.querySelector('.planet-selector')
  const list = document.createElement('ul')

  Object.entries(planets).forEach(([key, planet]) => {
    const li = document.createElement('li')
    if (key === 'earth') {
      li.classList.add('active')
    }

    const img = document.createElement('img')
    img.className = 'planet-thumb'
    img.src = planet.dayTexture
    img.alt = `${planet.name}`
    img.dataset.planet = key

    const label = document.createElement('span')
    label.textContent = planet.name

    li.appendChild(img)
    li.appendChild(label)
    li.addEventListener('click', () => {
      window.switchPlanet(key)
    })
    list.appendChild(li)
  })

  selector.appendChild(list)
}

export function createPlanetInfobox(planetKey) {

  const infoBox = document.querySelector('.planet-infobox')
  
  if (infoBox) {
        infoBox.innerHTML = '';
    }

  if (!infoBox) {
      console.error("Container '.planet-infobox' not found.");
      return;
  }

  const planet = planets[planetKey]
  const nameElement = document.createElement('h1')
  nameElement.id = 'planet-name';
  const name = planet.name
  nameElement.textContent = name

  const descriptionElement = document.createElement('p')
  descriptionElement.id = 'planet-description';
  const description = planet.description
  descriptionElement.textContent = description

  const statsElementUl = document.createElement('ul')
  statsElementUl.id = 'planet-stats';
  const stats = [
    `Diameter: ${planet.diameter}`,
    `Distance from Sun: ${planet.distanceFromSun}`,
    `Rotation period: ${planet.rotationPeriod}`,
    `Orbital period: ${planet.orbitalPeriod}`,
    `Moons: ${planet.moons}`,
    `Composition: ${planet.composition}`
  ]
  stats.map((stat) => {
    const statsElementLi = document.createElement('li')
    statsElementLi.textContent = `${stat}`
    statsElementUl.appendChild(statsElementLi)
  })

  const funFactElement = document.createElement('p')
  funFactElement.id = 'planet-funFact';
  const funFact = planet.funFact
  funFactElement.textContent = funFact

  infoBox.appendChild(nameElement)
  infoBox.appendChild(descriptionElement)
  infoBox.appendChild(statsElementUl)
  infoBox.appendChild(funFactElement)
}
